<template>
	<div class="main-header">
		<div class="custom-header">
			<router-link to="/" >
				<img class="logo" src="@/assets/images/logo@2x.png" />
			</router-link>
			<div class="menu">
				<router-link to="/" class="menu-item" :class="currentTab == 'Home' ? 'active' :''">Discover</router-link>
				<!-- <router-link to="/info" class="menu-item" :class="['Info','InfoDetail'].includes(currentTab) ? 'active':''">News</router-link> -->
				<!-- <router-link to="/contest" class="menu-item" :class="currentTab == 'Contest' ? 'active':''">Competition</router-link> -->
			</div>
			<div class="search" :style="{opacity:curr_opacity}">
				<!-- <input placeholder="What type of design are you interested in?" class="search-input" v-model="keyword" @keyup.enter="onSearch" />
				<Icon v-if="keyword" type="md-close" size="20" style="cursor:pointer;" @click="keyword=''"></Icon>
				<img src="@/assets/images/icon-search-pink.png" class="search-ico" @click="onSearch" /> -->
			</div>
			<div class="right-box">
				<Poptip trigger="hover" placement="bottom" :transfer="false" popper-class="creator-pop" width="180">
					<template #content>
						<div class="creator-box" ref="creatorBox">
							<div class="item-box">
								<div class="menu-item" @click="onShowDesign">
									<img src="../assets/images/icon-design-menu.png" />Style design
								</div>
								<div class="menu-item" @click="onCreatePosts">
									<img src="../assets/images/icon-post-menu.png" />Create a post
								</div>
								<!-- <div class="menu-item">发布文章</div> -->
							</div>
						</div>
					</template>
					<Button ref="creatorBtn" shape="circle" class="creator-btn" @click="onShowDesign">Start Design</Button>
				</Poptip>

				<template v-if="!is_login">
					<div class="login-box">
						<img src="@/assets/images/icon-user-header.png" style="width:22px;height:24px;" />
						<div class="login-btn" @click="goLogin">Sign in</div>
					</div>
					<!-- <div class="btn"  @click="goLogin">立即登录</div> -->
				</template>
				<template v-else>
					<div class="btn-wrap">
						<div class="msg-box" style="" @click="showChat()">
							<img src="@/assets/images/icon-msg.png" class="icon-msg" />
							<div class="msg-num" v-if="totalNum>0">{{totalNum}}</div>
						</div>
						<Poptip trigger="hover" placement="bottom-end">
							<template #content>
								<div class="avatar-dropdown-box">
									<div class="dropdown-top">
										<div class="dropdown-nick-avatar">
											<!-- <img :src="userInfo.avatar | default_img" class="dropdown-avatar" /> -->
											<div class="dropdown-nick-job">
												<div class="dropdown-nick" style="">Hi~ {{userInfo.nickname || userInfo.mobile}}</div>
												<!-- <div class="dropdown-job" style="">{{userInfo.city ? `${userInfo.city && userInfo.job ? userInfo.city+ '|' : userInfo.city}`:''}}{{userInfo.job || ''}}</div> -->
											</div>
										</div>
									</div>

									<div class="dropdown-items-lists">
										<div class="dropdown-item" v-for="(item,index) in menu_list" :key="index" @click="tab(item)" @mouseenter="curr_menu=item.title" @mouseleave="curr_menu=''">
											<img :src="(curr_menu === item.title ? item.iconImgAct :item.iconImg)" class="dropdown-item-icon" />
											<div class="dropdown-item-title">{{item.title}}</div>
										</div>
									</div>

									<div class="dropdown-logout">
										<div class="dropdown-logout-btn" @click="tab({path: 'logout'})">
											Logout
										</div>
									</div>
								</div>
							</template>
							<img :src="userInfo.avatar|default_img" alt="" class="avatar" @click="go2center">
						</Poptip>
					</div>
				</template>
			</div>
			<create-posts v-if="show_creator_pop" @close-upload-pop="show_creator_pop = false" />
			<create-design v-if="show_design_pop" ref="createDesign" @close-design-pop="show_design_pop=false" @on-advanced-mode="(uuid)=>{start_design(uuid)}"></create-design>
			<chat ref="chat"></chat>
			<login-pop ref="loginPop" v-if="show_login_pop" @close-login="show_login_pop=false"></login-pop>
		</div>
	</div>
</template>

<script>
import Chat from "./Chat";
import CreatePosts from "./CreatePosts";
import CreateDesign from "./CreateDesign";
import LoginPop from "./LoginPop";
import { mapState, mapGetters } from "vuex";
import Vue from "vue";
export default {
  name: "Header",
  components: {
    Chat,
    CreatePosts,
    CreateDesign,
    LoginPop,
  },
  props: {
    show_back: {
      type: Boolean,
      default: false,
    },
    show_login: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      msg_count: 0,
      show_creator_pop: false,
      show_creator: false,
      show_design_pop: false,
      menu_list: [
        {
          title: "Workbenches",
          path: "workbench/home",
          iconImg: require("../assets/images/icon-workbench-dropdown.png"),
          iconImgAct: require("../assets/images/icon-workbench-dropdown-active.png"),
        },
        {
          title: "My shop",
          path: "shop/home",
          iconImg: require("../assets/images/icon-store-dropdown.png"),
          iconImgAct: require("../assets/images/icon-store-dropdown-active.png"),
        },
        {
          title: "My design",
          path: "style",
          iconImg: require("../assets/images/icon-style-dropdown.png"),
          iconImgAct: require("../assets/images/icon-style-dropdown-active.png"),
        },
        {
          title: "My post",
          path: "design",
          iconImg: require("../assets/images/icon-design-dropdown.png"),
          iconImgAct: require("../assets/images/icon-design-dropdown-active.png"),
        },
        {
          title: "Order Center",
          path: "/order/center",
          iconImg: require("../assets/images/icon-order-dropdown.png"),
          iconImgAct: require("../assets/images/icon-order-dropdown-active.png"),
        },
        {
          title: "Personal Center",
          path: "/workbench/center",
          iconImg: require("../assets/images/icon-mine-dropdown.png"),
          iconImgAct: require("../assets/images/icon-mine-dropdown-active.png"),
        },
      ],
      keyword: "",
      curr_menu: "",
      curr_opacity: 0,
      lastScrollTop: 0,
      show_login_pop: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      form_data: (state) => state.design.form_data,
    }),

    ...mapGetters({
      totalNum: "scoket/totalNum",
    }),
    is_login() {
      return this.$store.state.is_login;
    },
    currentTab() {
      return this.$route.name;
    },
  },
  created() {
    if (this.is_login) {
      this.$store.dispatch("scoket/webSocketInit");
      this.$store.dispatch("scoket/getMessage");
    }
  },
  mounted() {
    this.route_name = this.$route.name;
    if (this.route_name !== "Home") {
      this.opacity = 1;
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  watch: {
    $route(to) {
      const { keyword } = to.params;
      if (keyword) {
        this.keyword = keyword;
      } else {
        this.keyword = "";
      }
    },
    "$route.name"(news, olds) {
      if (news !== "Home") {
        this.route_name = news;
        this.curr_opacity = 1;
      } else {
        this.curr_opacity = 0;
      }
    },
    is_login(newVal, oldVal) {
      if (newVal) {
        this.$store.dispatch("scoket/webSocketInit");
        this.$store.dispatch("scoket/getMessage");
      }
    },
  },
  methods: {
    onShowDesign() {
      if (!this.is_login) {
        // this.$router.push({name:'Login'});
        this.$layer.msg("Please login first");
        this.show_login_pop = true;
        return;
      }
      this.show_design_pop = true;
    },
    handleScroll() {
      const routeName = this.$route.name;
      if (routeName !== "Home") {
        this.curr_opacity = 1;
        return;
      }

      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      // 如果滚动到顶部，显示搜索框
      if (currentScrollTop <= 0) {
        this.curr_opacity = 0;
        this.lastScrollTop = 0;
        return;
      }

      // 滚动距离超过 10px 才触发显示/隐藏逻辑，避免微小滚动触发
      if (Math.abs(currentScrollTop - this.lastScrollTop) <= 10) {
        return;
      }

      // 向下滚动时隐藏搜索框，向上滚动时显示搜索框
      if (currentScrollTop > this.lastScrollTop && currentScrollTop > 350) {
        // 向下滚动且超过350px
        this.curr_opacity = 1;
      } else if (currentScrollTop < this.lastScrollTop) {
        // 向上滚动时隐藏搜索框
        this.curr_opacity = 0;
      }

      this.lastScrollTop = currentScrollTop;
    },
    onSearch() {
      const { keyword } = this;
      if (!keyword) {
        this.$layer.msg("Please enter the search content");
        return;
      }
      this.$router.push({ name: "Search", params: { keyword } });
    },
    showChat() {
      if (this.route_name == "WorkBenchDesign" && this.form_data.uuid) {
        this.$refs["chat"].showChat({
          uuid: this.form_data.uuid,
          image: this.form_data.image,
          name: this.form_data.name,
          from: "draft",
        });
        return;
      }
      this.$refs["chat"].showChat();
    },
    onCreatePosts() {
      if (!this.is_login) {
        this.$layer.msg("Please login first");
        this.$router.replace({ name: "Login" });
        return;
      }
      this.show_creator_pop = true;
      // this.$router.push({
      // 	name:'Posts'
      // })
    },
    tab(e) {
      const path = e.path;
      switch (path) {
        case "logout":
          this.$store.commit("logout");
          this.$router.push({
            path: "/",
          });
          break;
        case "workbench/home":
          this.$router.push({
            path: "/workbench/home",
          });
          break;
        case "style":
          this.$router.push({
            path: "/workbench/template",
          });
          break;
        case "shop/home":
          this.$router.push({
            path: "/shop/home",
            query: {
              uid: this.userInfo.code,
            },
          });
          break;
        case "design":
          this.$router.push({ name: "MyCreations" });
          break;
        default:
          this.$router.push({
            path: e.path,
          });
          break;
      }
      // if(e.path == 'logout') {
      // 	this.$store.commit('logout')
      // 	this.$router.push({
      // 		path: '/'
      // 	})
      // 	return
      // }
      // if(e.path == 'workbench/home'){
      // 	this.$router.push({
      // 		path: '/workbench/home'
      // 	})
      // 	return;
      // }
      return;
      // this.$router.push({
      // 	path: '/user/' + e.path
      // })
    },
    go2center() {
      this.$router.push({ name: "WorkBenchHome" });
    },
    start_design() {
      this.show_creator = false;
      let route = this.$router.resolve({ name: "WorkBenchDesign" });
      window.open(route.href, "_blank");
    },
    goBack() {
      this.$router.back();
    },
    goLogin() {
      // if (!this.$store.getters.isLoginDynamic()) {
      if (!this.is_login) {
        this.$store.commit("update_login_state", false);
        this.$router.push({
          path: "/login",
        });
        return;
      }
      this.$router.replace({
        path: "/workbench/center",
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ivu-poptip-arrow {
  display: none !important;
}

::v-deep .ivu-poptip-content {
  border-radius: 15px !important;
}

::v-deep .ivu-poptip-inner {
  border-radius: 15px !important;
}

::v-deep .ivu-poptip-body {
  padding: 0px !important;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px #b3b3b3;
  border-radius: 15px !important;
}

.creator-box {
  background: #ffffff;
  // width: 170px;
  border-radius: 15px;
  font-size: 16px;
  text-align: left;
  margin: 10px 5px;
  .item-box {
    // padding:10px 0px;
    .menu-item {
      // width:170px;
      display: flex;
      align-items: center;
      height: 45px;
      line-height: 45px;
      color: #000000;
      cursor: pointer;
      padding-left: 25px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 8px;
      }
      &:hover {
        border-radius: 10px;
        background: #f5f5f5;
        color: #000000;
      }
    }
  }
}

.main-header {
  display: flex;
  width: 100%;
  min-width: 1680px;
  max-width: 1920px;
  position: sticky;
  top: 0;
  z-index: 100;
  input {
    outline: none !important;
  }
  .custom-header {
    flex: 1;
    // width: 100%;
    // max-width:1920px;
    height: 80px;
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 0 80px 0 53px;
    border-bottom: 1px solid #e8e8eb;
    // overflow:auto;
    .logo {
      display: block;
      width: 162px;
      height: 41px;
    }

    .login-box {
      display: flex;
      align-items: center;
      justify-content: center;

      .login-btn {
        white-space: nowrap;
        font-weight: bold;
        font-size: 16px;
        margin-left: 10px;
        cursor: pointer;
        color: #000000;
      }
    }

    .search {
      flex: 0 0 45%;
      display: flex;
      align-items: center;
      // position: relative;
      max-height: 48px;
      height: 100%;
      padding: 16px auto;
      margin-left: 50px;
      background: #f7f7f7;
      border-radius: 24px;
      transition: opacity 0.3s ease, transform 0.3s ease;
      .search-input {
        flex: 1;
        border: none !important;
        background: transparent;
        height: 100%;
        padding-left: 25px;
        padding-right: 5px;
      }

      .search-ico {
        width: 40px;
        height: 40px;
        margin-right: 8px;
        margin-left: 10px;
        cursor: pointer;
      }
    }

    .menu {
      display: flex;
      align-items: center;
      height: 100%;
      font-size: 16px;
      // flex: 0 0 20%;
      overflow-x: auto;
      // margin-left:30px;
      .menu-item {
        // overflow:hidden;
        // text-overflow:ellipsis;
        white-space: nowrap;
        // flex: 0 0 33.3%;
        margin-right: 40px;
        // text-align: center;
        color: #8b8b8b;
        cursor: pointer;
        &.active {
          font-weight: bold;
          color: #000000;
        }
      }
      &::-webkit-scrollbar {
        display: none !important;
      }
    }
    .right-box {
      display: flex;
      align-items: center;

      .creator-pop {
        ::v-deep .ivu-poptip-content .ivu-poptip-arrow {
          display: none !important;
        }
      }
      .creator-btn {
        // border-radius: 10px !important;
        background: #000000;
        border: none !important;
        color: #ffffff;
        height: 38px;
        font-size: 14px;
        margin-right: 30px;
        font-weight: bold;
      }
      .btn-wrap {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .msg-box {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          margin-right: 30px;

          .icon-msg {
            width: 34px;
            height: 34px;
            cursor: pointer;
          }

          .msg-num {
            top: -2px;
            right: 1px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            width: 16px;
            height: 16px;
            background: #ff5967;
            border-radius: 100%;
            color: #ffffff;
          }
        }
        .avatar {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          cursor: pointer;
          object-fit: cover;
        }
        .btn {
          margin: 0 5px;
          &.btn-home {
            background: #edeff2;
            color: #fa3d5a;
          }
          &.btn-start {
            background: #fa3d5a;
            color: white;
          }
        }
        .avatar-dropdown-box {
          background: #ffffff;
          border-radius: 15px;
          z-index: 999999;
          padding: 0 15px;

          .dropdown-top {
            border-bottom: 1px solid #ebebeb;
            display: flex;
            justify-content: center;

            .dropdown-nick-avatar {
              padding: 20px 30px;
              display: flex;
              align-items: center;

              .dropdown-avatar {
                width: 52px;
                height: 52px;
                border-radius: 100%;
                object-fit: cover;
              }

              .dropdown-nick-job {
                // margin-left: 10px;
                text-align: center;

                .dropdown-nick {
                  width: 100%;
                  font-size: 14px;
                  color: #1c1f23;
                  font-weight: bold;
                }

                .dropdown-job {
                  font-size: 12px;
                  color: #8b8b8b;
                  width: 100%;
                }
              }
            }
          }

          .dropdown-items-lists {
            padding: 0 35px 0 0;
            // padding-top: 30px;
            display: flex;
            justify-content: start;
            align-items: start;
            flex-direction: column;
            margin-top: 17px;
            row-gap: 19px;
            padding-bottom: 26px;
            margin-left: 28px;

            .dropdown-item {
              display: flex;
              justify-content: start;
              align-items: center;
              column-gap: 16px;
              // margin-left:31px;
              // flex-wrap: wrap;
              // width: 45px;
              cursor: pointer;
              // padding:0 25px 30px 25px;
              color: #5c5c5c;

              .dropdown-item-icon {
                width: 22px;
                height: 22px;
              }

              .dropdown-item-title {
                font-size: 12px;
              }
              &:hover {
                color: #fa3d5a;
              }
            }
          }
          .dropdown-logout {
            border-top: 1px solid #ebebeb;
            width: 100%;
            .dropdown-logout-btn {
              cursor: pointer;
              text-align: center;
              width: 100%;
              padding: 20px;
              color: #808080;
              font-size: 12px;
            }
          }
        }
      }
    }
    .btn {
      width: 110px;
      height: 30px;
      line-height: 30px;
      background: #fa3d5a;
      border-radius: 20px;
      font-size: 14px;
      text-align: center;
      cursor: pointer;
      color: white;
    }
  }
}

@media (min-width: 1280px) and (max-width: 1679px) {
  .main-header {
    display: flex;
    flex: 1;
    width: 100% !important;
    min-width: 1280px !important;
    max-width: 1679px !important;
    .custom-header {
      width: 100% !important;
      min-width: 1280px !important;
      max-width: 1679px !important;
      flex: 1;
      width: 100%;
      height: 72px !important;
      padding: 0 80px 0 53px;
      .logo {
        width: 136.8px !important;
        height: 38.7px !important;
        margin-right: 50px;
      }

      .login-box {
        .login-btn {
          font-size: 14px !important;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      .search {
        flex: 0 0 30%;
        max-height: 43.2px;
        height: 100%;
        padding: 14.4px auto;
        margin-left: 45px;
        .search-input {
          flex: 1;
          border: none !important;
          background: #f7f7f7;
          height: 100%;
          border-radius: 24px;
          padding-left: 25px;
        }

        .search-ico {
          width: 18.9px;
          height: 18.9px;
          top: 25%;
          right: 5%;
          bottom: 0;
        }
      }

      .menu {
        height: 100%;
        font-size: 16px;
        .menu-item {
          margin-right: 32px;
          &.active {
            font-weight: bold;
            color: #000000;
          }
        }
        &::-webkit-scrollbar {
          display: none !important;
        }
      }
      .right-box {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        .creator-btn {
          height: 34.2px;
          font-size: 14px;
          margin-right: 27px;
        }

        .btn-wrap {
          .msg-box {
            margin-right: 27px;

            .icon-msg {
              width: 26.6px;
              height: 26.6px;
            }

            .msg-num {
              top: -2px;
              right: 1px;
              font-size: 10px;
              width: 14.4px;
              height: 14.4px;
            }
          }
          .avatar {
            width: 34.2px;
            height: 34.2px;
            border-radius: 50%;
            cursor: pointer;
          }
          .btn {
            margin: 0 5px;
            &.btn-home {
              background: #edeff2;
              color: #fa3d5a;
            }
            &.btn-start {
              background: #fa3d5a;
              color: white;
            }
          }
          .avatar-dropdown-box {
            background: #ffffff;
            border-radius: 15px;
            z-index: 999999;
            padding: 0 15px;

            .dropdown-top {
              border-bottom: 1px solid #ebebeb;
              display: flex;
              justify-content: center;

              .dropdown-nick-avatar {
                padding: 20px 30px;
                display: flex;
                align-items: center;

                .dropdown-avatar {
                  width: 52px;
                  height: 52px;
                  border-radius: 100%;
                  object-fit: cover;
                }

                .dropdown-nick-job {
                  // margin-left: 10px;
                  text-align: center;

                  .dropdown-nick {
                    width: 100%;
                    font-size: 14px;
                    color: #1c1f23;
                    font-weight: bold;
                  }

                  .dropdown-job {
                    font-size: 12px;
                    color: #8b8b8b;
                    width: 100%;
                  }
                }
              }
            }

            .dropdown-items-lists {
              padding: 0 35px 0 0;
              // padding-top: 30px;
              display: flex;
              justify-content: start;
              align-items: start;
              flex-direction: column;
              margin-top: 17px;
              row-gap: 19px;
              padding-bottom: 26px;
              margin-left: 28px;

              .dropdown-item {
                display: flex;
                justify-content: start;
                align-items: center;
                column-gap: 16px;
                // margin-left:31px;
                // flex-wrap: wrap;
                // width: 45px;
                cursor: pointer;
                // padding:0 25px 30px 25px;
                color: #5c5c5c;

                .dropdown-item-icon {
                  width: 22px;
                  height: 22px;
                }

                .dropdown-item-title {
                  font-size: 12px;
                }
                &:hover {
                  color: #fa3d5a;
                }
              }
            }
            .dropdown-logout {
              border-top: 1px solid #ebebeb;
              width: 100%;
              .dropdown-logout-btn {
                cursor: pointer;
                text-align: center;
                width: 100%;
                padding: 20px;
                color: #808080;
                font-size: 12px;
              }
            }
          }
        }
      }
      .btn {
        width: 110px;
        height: 30px;
        line-height: 30px;
        background: #fa3d5a;
        border-radius: 20px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        color: white;
      }
    }
  }
  .creator-box {
    width: 162px;
    font-size: 14px;
    .item-box {
      padding: 9px 0px;
      .menu-item {
        height: 40.5px;
        line-height: 40.5px;
      }
    }
  }
}

@media (max-width: 1279px) {
  .main-header {
    display: flex;
    width: 100% !important;
    min-width: 800px !important;
    max-width: 1279px !important;
    overflow: visible !important;
    .custom-header {
      width: 100%;
      max-width: 1279px;
      flex: 1;
      height: 64px;
      background: white;
      padding: 0 30px 0 53px;
      border-bottom: 1px solid #e8e8eb;
      .logo {
        display: block;
        width: 152px;
        height: 43px;
        margin-right: 40px;
      }

      .login-box {
        .login-btn {
          font-weight: bold;
          font-size: 12px;
          margin-left: 10px;
          cursor: pointer;
        }
      }

      .search {
        flex: 0 0 30%;
        display: flex;
        position: relative;
        max-height: 48px;
        height: 100%;
        padding: 16px auto;
        margin-left: 50px;
        .search-input {
          flex: 1;
          border: none !important;
          background: #f7f7f7;
          height: 100%;
          border-radius: 24px;
          padding-left: 25px;
        }

        .search-ico {
          width: 21px;
          height: 21px;
          position: absolute;
          top: 30%;
          right: 5%;
          bottom: 0;
        }
      }

      .menu {
        height: 100%;
        font-size: 14px;
        .menu-item {
          margin-right: 32px;
        }
      }
      .right-box {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex: 1;
        .creator-btn {
          height: 30.4px;
          font-size: 14px;
          margin-right: 27px;
        }

        .btn-wrap {
          .msg-box {
            margin-right: 27px;
            .icon-msg {
              width: 30px;
              height: 30px;
            }

            .msg-num {
              top: -2px;
              right: 1px;
              font-size: 10px;
              width: 14px;
              height: 14px;
            }
          }
          .avatar {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            cursor: pointer;
          }
          .btn {
            margin: 0 5px;
            &.btn-home {
              background: #edeff2;
              color: #fa3d5a;
            }
            &.btn-start {
              background: #fa3d5a;
              color: white;
            }
          }
          .avatar-dropdown-box {
            background: #ffffff;
            border-radius: 15px;
            z-index: 999999;
            padding: 0 15px;

            .dropdown-top {
              border-bottom: 1px solid #ebebeb;
              display: flex;
              justify-content: center;

              .dropdown-nick-avatar {
                padding: 20px 30px;
                display: flex;
                align-items: center;

                .dropdown-avatar {
                  width: 52px;
                  height: 52px;
                  border-radius: 100%;
                  object-fit: cover;
                }

                .dropdown-nick-job {
                  // margin-left: 10px;
                  text-align: center;

                  .dropdown-nick {
                    width: 100%;
                    font-size: 14px;
                    color: #1c1f23;
                    font-weight: bold;
                  }

                  .dropdown-job {
                    font-size: 12px;
                    color: #8b8b8b;
                    width: 100%;
                  }
                }
              }
            }

            .dropdown-items-lists {
              padding: 0 35px 0 0;
              // padding-top: 30px;
              display: flex;
              justify-content: start;
              align-items: start;
              flex-direction: column;
              margin-top: 17px;
              row-gap: 19px;
              padding-bottom: 26px;
              margin-left: 28px;

              .dropdown-item {
                display: flex;
                justify-content: start;
                align-items: center;
                column-gap: 16px;
                // margin-left:31px;
                // flex-wrap: wrap;
                // width: 45px;
                cursor: pointer;
                // padding:0 25px 30px 25px;
                color: #5c5c5c;

                .dropdown-item-icon {
                  width: 22px;
                  height: 22px;
                }

                .dropdown-item-title {
                  font-size: 12px;
                }
                &:hover {
                  color: #fa3d5a;
                }
              }
            }
            .dropdown-logout {
              border-top: 1px solid #ebebeb;
              width: 100%;
              .dropdown-logout-btn {
                cursor: pointer;
                text-align: center;
                width: 100%;
                padding: 20px;
                color: #808080;
                font-size: 12px;
              }
            }
          }
        }
      }
      .btn {
        width: 110px;
        height: 30px;
        line-height: 30px;
        background: #fa3d5a;
        border-radius: 20px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        color: white;
      }
    }
  }
  .creator-box {
    width: 144px;
    border-radius: 15px;
    font-size: 14px;
    .item-box {
      padding: 8px 0px;
      .menu-item {
        height: 36px;
        line-height: 36px;
      }
    }
  }
}
</style>
